export function observeResizeWithAnimationFrame(element: Element, onResize: (entry: ResizeObserverEntry) => void) {
  let animationFrameId: number | null = null;
  let latestEntry: ResizeObserverEntry | null = null;

  const flush = () => {
    animationFrameId = null;
    const entry = latestEntry;
    latestEntry = null;

    if (!entry) {
      return;
    }

    onResize(entry);
  };

  const observer = new ResizeObserver((entries) => {
    latestEntry = entries[entries.length - 1] ?? null;

    if (!latestEntry || animationFrameId !== null) {
      return;
    }

    animationFrameId = requestAnimationFrame(flush);
  });

  observer.observe(element);

  return () => {
    observer.disconnect();
    if (animationFrameId !== null) {
      cancelAnimationFrame(animationFrameId);
    }
  };
}
